<template>
	<button type="button" class="visually-hidden" data-bs-toggle="modal" data-bs-target="#mapModal"
		id="mapModalBTN"></button>

	<div class="modal fade" id="mapModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" style="z-index: 99999;">
		<div class="modal-dialog">
			<div class="modal-content dir-rtl">
				<div class="modal-header pb-2 border-bottom">
					<h5 class="fw-bold">انتخاب آدرس</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" id="mapModalCloseBTN"></button>
				</div>
				<div class="modal-body p-0" :class="{ 'h-sp': mapTempFlag == 2 }">
					<div class="p-2" id="locationTemp" v-if="mapTempFlag == 1">
						<div class="location-item">
							<div class="form-check mb-3 pl-0" v-if="locations.location.string">
								<input class="form-check-input my-font" type="radio" id="address-item-1" name="location"
									value="1" @click="setLocation(locations.location.ind)">
								<label class="form-check-label me-1" style="font-size:14px" for="address-item-1">{{
									locations.location.string }}</label>
								<div class="d-inline-block">
									<button class="btn bg-transparent border-0 pe-2 p-0"
										@click="deleteAddress(locations.location.ind)">
										<i class="bi bi-trash" style="vertical-align:sub"></i>
									</button>
								</div>
							</div>
							<div class="form-check mb-3 pl-0" v-if="locations.location2.string">
								<input class="form-check-input my-font" type="radio" name="location" id="address-item-2"
									value="1" @click="setLocation(locations.location2.ind)">
								<label class="form-check-label me-1" style="font-size:14px" for="address-item-2">{{
									locations.location2.string }}</label>
								<div class="d-inline-block">
									<button class="btn bg-transparent border-0 pe-2 p-0"
										@click="deleteAddress(locations.location2.ind)">
										<i class="bi bi-trash" style="vertical-align:sub"></i>
									</button>
								</div>
							</div>
							<div class="form-check mb-3 pl-0" v-if="locations.location3.string">
								<input class="form-check-input my-font" type="radio" name="location" id="address-item-3"
									value="1" @click="setLocation(locations.location3.ind)">
								<label class="form-check-label me-1" style="font-size:14px" for="address-item-3">{{
									locations.location3.string }}</label>
								<div class="d-inline-block">
									<button class="btn bg-transparent border-0 pe-2 p-0"
										@click="deleteAddress(locations.location3.ind)">
										<i class="bi bi-trash" style="vertical-align:sub"></i>
									</button>
								</div>
							</div>
						</div>
						<button class="bg-transparent border-0 pe-0 add-location" v-if="plusAddress">
							<i class="bi bi-plus-circle ps-1"></i>
							<a class="form-check-label me-1 fw-bold" style="font-size:14px;text-decoration: none;"
								href="javascript:void(0)" @click="getPlusAddress(1)">
								افزودن آدرس
							</a>
						</button>
					</div>

					<map-temp @location="setMapLocation" :location="mapLocation" v-else-if="mapTempFlag == 2" />

					<div class="pt-2 p-3" v-else-if="mapTempFlag == 3">
						<div class="d-flex justify-content-between">
							<label class="form-label">جزئیات آدرس</label>
							<span @click="getPlusAddress">
								<small class="ms-1">مرحله قبل</small>
								<i class="bi bi-arrow-left-circle"></i>
							</span>
						</div>
						<div style="width: 100%; height: 140px;">
							<map-tv :location="mapLocation" />
						</div>
						<div>
							<span class="mb-2 d-block text-body-1 color-700">نشانی پستی</span>
							<small class="mt-3 d-block">
								<img src="https://radap.ir/imagesUploaded/other/warning.png" style="width: 27px;">
								جهت اطمینان آدرس را چک نموده و اطلاعات موردنیاز را وارد نمایید.
							</small>
							<input type="text" id="postLocation" class="form-control mb-2 h-40 my-color" readonly
								v-model="finallLocation" @click="getAlertNoEdit" />
							<input type="text" id="descriptionLocation" class="form-control mb-2 h-40 my-color"
								placeholder="آدرس دقیق(جهت راهنمایی بهتر)" v-model="descriptionLocation" />
							<div class="d-flex gap-2">
								<input type="text"
									class="form-control mb-2 w-50 h-40 d-inline-block my-color text-left dir-ltr"
									placeholder="پلاک" v-model="mapLocation.plaque">
								<input type="text"
									class="form-control mb-2 w-45 h-40 d-inline-block my-color text-left dir-ltr"
									placeholder="واحد" v-model="mapLocation.unit">
							</div>
							<button class="btn btn-info w-100 h-40" @click="addNewAddress">ثبت آدرس</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<loading-vue v-if="loading" />
</template>

<script setup>
import axios from 'axios';
import MapTemp from '../item/MapTemp.vue'
import MapTv from '../item/MapTv.vue'
import { onMounted, ref, watch, reactive } from 'vue';
import LoadingVue from '@/components/section/item/loading.vue';
import { useBasket } from '@/store/basket'
import { alertBox } from '@/composables/silverBox';
import { useAuth } from '@/store/auth'
const storeBasket = useBasket();
let auth = useAuth()
let locations = reactive({
	location: { ind: '', string: '' },
	location2: { ind: '', string: '' },
	location3: { ind: '', string: '' }
});
// loading flag
let loading = ref(false)
// ادرس خام جدید ساخته شده
// let plusLocation = ref();
// ساخت ادرس نهایی بهمراه پلاک و واحد
let finallLocation = ref()
// شماره ادرسی که قرار است ویرایش شود
// let editInd = ref(0)
// مختصات ادرس نهایی سبد خرید
let finallCoordinates = ref()
// متغیر چندمین آدرس
let ind = ref('a0')
// متغیر تعدادآدرس ها (زیر3 تا)
let plusAddress = ref(true);
// سوئیچ کننده مراحل 1،2,3 پاپاپ
let mapTempFlag = ref(1)
let mapLocation = reactive({
	post: '',
	plaque: '',
	unit: '',
	lat: '',
	lng: ''
})
let descriptionLocation = ref('')
onMounted(() => {
	getLocations()
})
watch(mapLocation, () => {
	if (mapLocation.post != '') {
		mapTempFlag.value = 3
		finallLocation.value = mapLocation.post
	}
	if (mapLocation.plaque != '') {
		finallLocation.value += ' پلاک' + mapLocation.plaque
	}
	if (mapLocation.unit != '') {
		finallLocation.value += ' واحد' + mapLocation.unit
	}
})
async function getLocations() {
	//دریافت لوکیشن های کاربر از سرور
	auth.getToken()
	if (auth.token) {
		let response = await fetch('https://radap.ir/Backend/api/account/location/all.php?token=' + auth.token)
		let data = await response.json()
		if (data) {

			locations.location = data[0]
			locations.location2 = data[1]
			locations.location3 = data[2]
		}

		if (locations.location.string && locations.location2.string && locations.location3.string) {
			// اگر 3 لوکیشن پر بود دکمه افزودن ادرس جدید غیر فعال شود
			plusAddress.value = false;
		} else {
			plusAddress.value = true;
		}
		loading.value = false
	}

}
function setLocation(num) {
	// انتخاب ادرس شماره num بعنوان ادرس سبدخرید
	if (num == '') {
		num = 1
	}
	getLocation(num)
		.then(data => {
			document.getElementById('locationHeaderTemp').value = data
			storeBasket.location = data
			getCoordinates(num)
				.then(cData => {
					document.getElementById('locationCoordinatesHeaderTemp').value = cData
					storeBasket.coordinates = cData
					getLocations()
					goBasket()
				})
		})

}
async function getCoordinates(num) {
	// گرفتن مختصات ادرس انتخابی
	let request = await fetch('https://radap.ir/Backend/api/account/location/get.php?prioarity=' + num + '&userId=' + auth.profile.id + '&type=1')
	let response = await request.text()
	return response;
}
async function getLocation(num) {
	// گرفتن مختصات ادرس انتخابی
	let request = await fetch('https://radap.ir/Backend/api/account/location/get.php?prioarity=' + num + '&userId=' + auth.profile.id + '&type=2')
	let response = await request.text()
	return response;
}
function goBasket() {
	// document.getElementById('basketModal').removeAttribute('inert');
	// document.getElementById('mapModal').setAttribute('inert', '');
	storeBasket.getBasketPopup()
	loading.value = false
}
function getPlusAddress(type = null) {
	if (type == 1) {
		mapLocation.post = '';
		mapLocation.plaque = '';
		mapLocation.unit = '';
		mapLocation.lat = '';
		mapLocation.lng = '';
	}
	mapTempFlag.value = 2
}
function setMapLocation(location) {
	mapLocation.post = location.string
	mapLocation.lat = location.lat
	mapLocation.lng = location.lng
}
function setDescriptionAddress() {
	if (descriptionLocation.value) {
		finallLocation.value += '(' + descriptionLocation.value + ')'
	}
}
function addNewAddress() {
	auth.getToken()
	if (auth.token && auth.profile.id) {
		if (document.getElementById('postLocation').value.length >= 10) {
			loading.value = true
			setDescriptionAddress()
			finallCoordinates.value = mapLocation.lat + ',' + mapLocation.lng
			axios
				.get("https://radap.ir/Backend/api/account/location/new.php?location=" + finallLocation.value + '&userId=' + auth.profile.id + '&coordinates=' + finallCoordinates.value)
				.then(res => {
					mapTempFlag.value = 1
					let number = res.data.replace('location', '')
					setLocation(number)
					descriptionLocation.value = ''
				})
		} else {
			alertBox("آدرس نباید کمتر از 10 کاراکتر باشد")
		}
	} else {
		alertBox('لطفا ابتدا وارد شوید', 'info', 2)
		document.querySelector('#loginsModalBTN').click();
	}
}
function deleteAddress(num) {
	loading.value = true
	let request = fetch('https://radap.ir/Backend/api/account/location/delete.php?prioarity=' + num + '&userId=' + auth.profile.id)
	request.then(res => {
		if (res.ok) {
			getLocations()
		}
	})
}
function getAlertNoEdit() {
	alertBox('نشانی انتخابی روی نقشه قابل تغییر نیست، لطفا در کادر پایین توضیحات دقیق آدرس را بنویسید')
}
</script>
<style scoped>
.show {
	display: block !important;
}

.bd-example {
	position: relative;
	padding: 1rem;
	margin: 1rem -0.75rem 0;
}

.w-45 {
	width: 47%;
}

.form-check .form-check-input {
	float: right;
}

.my-font {
	font-size: 15px;
}

.label {
	display: inline-block;
	max-width: 100%;
	margin-bottom: 5px;
	font-weight: 700;
}

.h-40 {
	height: 40px;
}

.my-color {
	background-color: #fff2f2;
}

.h-sp {
	/* height: 43.7vh; */
	height: 560px;
}
</style>